import { fetch, create, update } from "./API";
import type {
  FetchVehiclesParams,
  VehiclePayload,
  BulkUpsertPayload,
} from "../helpers/interfaces/VehiclesInterfaces";

const BASE_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

const vehicleHeaders = () => ({
  "Content-Type": "application/json",
  "x-api-key": API_KEY || "",
});

// GET /vehicles  (paginated + search + sort + filters)
export const fetchVehicles = async (params?: FetchVehiclesParams) => {
  try {
    return await fetch(`${BASE_URL}/vehicles`, { ...params }, vehicleHeaders());
  } catch (err: any) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    return err.message;
  }
};

export const searchVehiclesByFMV = async (searchTerm: string) => {
  try {
    return await fetch(
      `${BASE_URL}/vehicles/fmv/search`,
      { search: searchTerm },
      vehicleHeaders()
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};

// GET /vehicles/:vehicle_id
export const getVehicleById = async (vehicleId: number) => {
  try {
    return await fetch(
      `${BASE_URL}/vehicles/${vehicleId}`,
      {},
      vehicleHeaders()
    );
  } catch (err: any) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    return err.message;
  }
};

// GET /vehicles/search/:bmtytl_code
export const searchVehicleByBmtytl = async (bmtytlCode: string) => {
  try {
    return await fetch(
      `${BASE_URL}/vehicles/search/${encodeURIComponent(bmtytlCode)}`,
      {},
      vehicleHeaders()
    );
  } catch (err: any) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    return err.message;
  }
};

// POST /vehicles
export const createVehicle = async (payload: VehiclePayload) => {
  try {
    return await create(`${BASE_URL}/vehicles`, payload, {
      headers: vehicleHeaders(),
    });
  } catch (err: any) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    return err.message;
  }
};

// PUT /vehicles/:vehicle_id
export const updateVehicle = async (
  vehicleId: number,
  payload: VehiclePayload
) => {
  try {
    return await update(`${BASE_URL}/vehicles/${vehicleId}`, payload, {
      headers: vehicleHeaders(),
    });
  } catch (err: any) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    return err.message;
  }
};

// POST /vehicles/bulk-upsert
export const bulkUpsertVehicles = async (payload: BulkUpsertPayload) => {
  try {
    return await create(`${BASE_URL}/vehicles/bulk-upsert`, payload, {
      headers: vehicleHeaders(),
    });
  } catch (err: any) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    return err.message;
  }
};
